import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

export const THEME_STORAGE_KEY = 'arawra.social.theme';
const ThemeContext = createContext(null);
const validTheme = (value) => value === 'light' || value === 'dark';
const systemTheme = () => typeof window !== 'undefined' && window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
const initialTheme = () => {
  try {
    const saved = window.localStorage.getItem(THEME_STORAGE_KEY);
    if (validTheme(saved)) return saved;
  } catch {}
  return systemTheme();
};

export function ThemeProvider({ children }) {
  const [theme, updateTheme] = useState(initialTheme);
  const setTheme = useCallback((value) => {
    if (!validTheme(value)) return;
    updateTheme(value);
    try { window.localStorage.setItem(THEME_STORAGE_KEY, value); } catch {}
  }, []);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    document.documentElement.style.colorScheme = theme;
  }, [theme]);

  useEffect(() => {
    const receive = (event) => {
      if (event.key === THEME_STORAGE_KEY) updateTheme(validTheme(event.newValue) ? event.newValue : systemTheme());
    };
    window.addEventListener('storage', receive);
    return () => window.removeEventListener('storage', receive);
  }, []);

  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const next = theme === 'dark' ? 'light' : 'dark';
  return <button type="button" className="theme-toggle" aria-label="Dark theme" aria-pressed={theme === 'dark'}
    title={`Switch to ${next} theme`} onClick={() => setTheme(next)}>{theme === 'dark' ? 'Dark' : 'Light'}</button>;
}

export function ThemeSetting() {
  const { theme, setTheme } = useTheme();
  return <section className="card theme-setting" aria-labelledby="appearance-heading">
    <h3 id="appearance-heading">Appearance</h3>
    <label htmlFor="social-theme">Theme</label>
    <select id="social-theme" value={theme} onChange={(event) => setTheme(event.target.value)}>
      <option value="light">Light</option><option value="dark">Dark</option>
    </select>
  </section>;
}
